
const events={

    heading:'Events Overview',
    headingDescription:'Organize and Celebrate Team Events',
    cardTabName:'Card View',
    calendarTabName:'Calendar View',
    addEventButtonText:'Add Event',
    gotoMediaHubButton:'Visit Gallery',


    EventFormModal: {
        editEventModalTitle: 'Edit Event',
        addEventModalTitle: 'Add New Event',
        submitButtonText:'Submit'
    },

    toolbar:{
         todayButtonText:'Today',
         gotoMonthButtonText:'Month',
         gotoWeekButtonText:'Week',
         gotoDaysButtonText:'Day',
    },
    addPhotoButtonText:'Add Photo',
    viewGalleryButtonText:'View Gallery',
    viewDetailButtonText:'View Detail',
    todaySearchResultText:'Showing events happening today in ',
    upcomingSearchResultText:'Showing upcoming events from today through ',
    passedSearchResultText:'Showing events that have already passed in ',





}

export default events;
